import MenuItem from '@mui/material/MenuItem';
import styled from 'styled-components';

export const DeleteMenuItem = styled(MenuItem)`
  color: var(--danger);
`;
